import { Component, Input, OnInit } from '@angular/core';
import { AvatarShape } from '../../utils/avatar/avatar-shape.enum';
import { AvatarSize } from '../../utils/avatar/avatar-size.enum';
import { IconComponentConfig } from '../../utils/icon/icon-component-config.interface';
import { BorderConfig, BoxShadowConfig, ColorConfig, SizeConfig, SpacingConfig } from '../../utils/shared';
import { computeBorderStyles } from '../../utils/set-border-and-radius';

@Component({
  selector: 'rappider-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class RappiderAvatarComponent implements OnInit {
  /* avatar text */
  @Input() text: string;
  /**
   * iconName is deprecated use icon input instead
   *
   * @type {string}
   * @memberof RappiderAvatarComponent
   */
  @Input() iconName: string;
  /* displayed icon's name */
  @Input() icon: IconComponentConfig;
  /* avatar shape */
  @Input() shape: AvatarShape;
  /* avatar image url */
  @Input() imageUrl: string;
  /* alternate text */
  @Input() altText: string;
  /* css style eg. backgroundColor */
  @Input() cssStyle: string;
  /* avatar size */
  @Input() size: AvatarSize | number;
  /* avatar description */
  @Input() tooltipText?: string;
  @Input() description: string;
  @Input() borderSettings: BorderConfig;
  @Input() sizeSettings: SizeConfig;
  @Input() colorSettings: ColorConfig;
  @Input() boxShadowSettings: BoxShadowConfig;
  @Input() paddingSettings: SpacingConfig;
  @Input() marginSettings: SpacingConfig;

  borderStyles: any = {};

  ngOnInit(): void {
    this.setBorderStyles();
  }

  setBorderStyles(): any {
    this.borderStyles = computeBorderStyles({
      border: this.borderSettings?.border,
      borderRadius: this.borderSettings?.borderRadius
    });
  }
}
